/**
 * Updates the filter query parameter by replacing or adding a clause for a specific field.
 * @param currentFilter The current filter string.
 * @param field The field to update in the filter.
 * @param newClause The new clause to set for the field.
 * @returns The updated filter string or undefined if no clauses remain.
 */
export const updateFilterQueryParam = (
  currentFilter: string | undefined,
  field: string,
  newClause: string | undefined
): string | undefined => {
  const existingClauses = currentFilter ? currentFilter.split(' and ') : []
  const clausesWithoutField = existingClauses.filter(clause => !clause.startsWith(`${field} `))

  if (newClause) clausesWithoutField.push(newClause)

  return clausesWithoutField.length > 0 ? clausesWithoutField.join(' and ') : undefined
}
